/** Mount point for the SPA. The app now owns '/'. */
export const ROUTER_BASE = '/';

// Vite's dev server serves from "/", but the router mounts at ROUTER_BASE, so
// opening localhost:5173 directly would render a blank page.
//
// This has to run before createBrowserRouter(), which reads window.location at
// module-evaluation time. It lives here rather than in main.tsx because ES
// modules evaluate dependencies first: App.tsx imports ROUTER_BASE from this
// file, so this body is guaranteed to run before App.tsx creates the router.
// In main.tsx it would run *after* the router had already captured "/".
//
// No-op once ROUTER_BASE becomes "/" at cutover.
if (import.meta.env.DEV && !window.location.pathname.startsWith(ROUTER_BASE)) {
  window.history.replaceState(
    null,
    '',
    ROUTER_BASE + window.location.pathname + window.location.search,
  );
}

/** Background refresh for list/summary queries. Socket events patch the cache
 *  in between, so this is a safety net rather than the primary update path. */
export const POLL_MS = 30_000;
